import React from 'react';
import Dashboard from '../../Dashboard';
import { BrowserRouter, Route, Redirect, Switch } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import Auth from '../../Auth/components/Auth';

function Routes(props) {
  return (
    <BrowserRouter>
      <Switch>
        <Route path="/auth*" component={() => <Auth openSnack={props.openSnack} />  } />        
        <ProtectedRoute path="/dashboard*" component={() => <Dashboard openSnack={props.openSnack} />  } />        
        <Redirect to="/dashboard" />      
      </Switch>
    </BrowserRouter>    
  );
}

export default Routes;
                  